import { AD_SERVER_TYPE, adServers, API_KEY } from '../reusableFields'

export const getInitialValues = (rightHolderAdServer = {}) => {
  return {
    [AD_SERVER_TYPE]: rightHolderAdServer[AD_SERVER_TYPE] || adServers.adbutler,
    [API_KEY]: rightHolderAdServer[API_KEY] || ''
  }
}
